import { styled, css, Box } from '@mui/material'

const AppContainerWrapper = styled(Box, {
  name: 'AppContainer'
})(
  ({ theme }) => css`
    overflow: hidden;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    height: 100%;
    width: 100%;
    background-color: ${theme.palette.background.default};

    ${theme.breakpoints.up('sm')} {
      max-width: 360px;
      max-height: 760px;
      box-shadow: ${theme.shadows[12]};
      border-radius: 8px;
    }
  `
)

export default AppContainerWrapper
